/* eslint-disable max-len */
import { memo } from 'react';

interface IPlayIcon {
  fill?: string;
}

function PlayIcon({ fill = 'white' }: IPlayIcon) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="41"
      height="41"
      viewBox="0 0 41 41"
      fill="none"
    >
      <path
        d="M4.375 32.9646V20.4161V7.86761V4.25057C4.375 2.97834 5.78734 2.18222 6.91928 2.81639L35.7734 18.9819C36.9089 19.6181 36.9089 21.2142 35.7734 21.8503L6.91928 38.0158C5.78734 38.65 4.375 37.8539 4.375 36.5817V32.9646Z"
        fill={fill}
      />
    </svg>
  );
}

export default memo(PlayIcon);
